import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, HelpCircle, MessageCircle } from "lucide-react";
import { api } from "../lib/api";
import { messageCoach } from "../components/ShareWhatsApp";
import { Brand } from "../components/Logo";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { ResponseForm } from "../components/ResponseForm";

export const DEFAULT_MATCH = {
  club: "USC Jemappes U12 C", adversaire: "[Adversaire]", competition: "[Compétition]", date: "[Date du match]",
  heure: "[Heure du coup d'envoi]", rendez_vous: "[Heure de rendez-vous]", lieu: "[Stade / adresse]", domicile: true,
  infos_pratiques: "[Infos pratiques à venir]", afficher_infos: true,
};

export const isExpired = (m) => {
  if (!m?.date_limite_iso) return false;
  return Date.now() > new Date(`${m.date_limite_iso}T${m.heure_limite || "23:59"}:00`).getTime();
};

const ContactCoach = ({ match }) => (
  <button type="button" data-testid="deadline-contact-coach" onClick={() => messageCoach(match)}
    className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 font-semibold text-ink transition-transform duration-200 hover:-translate-y-0.5">
    <MessageCircle className="h-5 w-5" />Envoyer un message au coach
  </button>
);


export default function Convocation() {
  const [match, setMatch] = useState(DEFAULT_MATCH);
  const [aucune, setAucune] = useState(false);
  useEffect(() => {
    const c = new URLSearchParams(window.location.search).get("c");
    api.get("/match", { params: { ...(c ? { c } : {}), t: Date.now() } })
      .then((r) => { if (r.data?.id) setMatch(r.data); else setAucune(true); })
      .catch(() => {});
  }, []);

  return (
    <div className="bg-ink">
      <header className="fixed inset-x-0 top-0 z-50 border-b border-chalk/5 bg-ink/50 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-2.5 sm:px-10 sm:py-5">
          <Brand />
          <Link to="/coach" data-testid="nav-coach-access-button" className="inline-flex items-center gap-2 rounded-full border border-chalk/20 bg-ink/40 px-4 py-2 text-sm text-chalk backdrop-blur-xl transition-colors duration-300 hover:border-lime hover:text-lime">
            <Lock className="h-4 w-4" /> <span className="hidden sm:inline">Espace</span> coach
          </Link>
        </div>
        <Marquee compact type={match?.type} />
      </header>
      <Hero match={match}>
        {aucune ? (
          <div data-testid="no-convocation" className="rounded-[24px] border border-line bg-pitch/90 p-6 backdrop-blur-xl">
            <h2 className="font-display text-3xl uppercase text-chalk">Pas de convocation en cours</h2>
            <p className="mt-2 text-dim">Le coach n'a pas encore publié la prochaine convocation. Reviens bientôt !</p>
          </div>
        ) : isExpired(match) ? (
          <div data-testid="deadline-passed" role="alert" className="rounded-[24px] border border-signal bg-pitch/90 p-6 backdrop-blur-xl">
            <h2 className="font-display text-3xl uppercase text-signal">Délai de réponse dépassé</h2>
            <p className="mt-2 text-chalk">La date limite pour répondre à cette convocation est passée. Envoie un message au coach pour le prévenir.</p>
            <ContactCoach match={match} />
          </div>
        ) : (
          <ResponseForm convocationId={match.id} type={match.type} covoitLieu={match.covoit_lieu} covoitHeure={match.covoit_heure} infos={match.afficher_infos === false ? null : match.infos_pratiques} />
        )}
        <Link to={`/aide${match.court || match.id ? `?c=${match.court || match.id}` : ""}`} data-testid="help-link"
          className="mt-4 flex items-center justify-center gap-2 rounded-full border border-chalk/20 bg-ink/60 px-4 py-3 text-sm text-chalk backdrop-blur-xl transition-colors duration-300 hover:border-lime hover:text-lime">
          <HelpCircle className="h-4 w-4 text-lime" />Besoin d'aide ? Voir le guide pour les parents
        </Link>
      </Hero>
    </div>
  );
}
